import { Testimonial } from '../interfaces/log-in.interface';

export const TESTIMONIALS_DATA: Testimonial[] = [
  {
    id: 't-1',
    name: 'Alex Kim',
    title: 'MuroWay, Brand owner',
    score: 5,
    imgSrc: '/assets/images/login-display-users/alex-kim.jpg',
    comment:
      'I’ve been using RetailTech Inc. to start my new project and now I can’t imagine work without it.',
  },
  {
    id: 't-2',
    name: 'Elena Rostova',
    title: 'Lumina Studio, Head of Design',
    score: 5,
    imgSrc: '/assets/images/login-display-users/elena-rostova.jpg',
    comment: 'The user interface is intuitive and reduced our onboarding time significantly.',
  },
  {
    id: 't-3',
    name: 'David Chen',
    title: 'Apex Global, Lead Developer',
    score: 4,
    imgSrc: '/assets/images/login-display-users/david-chen.avif',
    comment:
      'Solid architecture and seamless integration. Highly recommended for modern tech stacks.',
  },
];
